export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_lG5h864yT',
      userPoolClientId: '1nsdr3rma2el4hilv63l2vkpqp',
      loginWith: {
        email: true,
      },
    },
  },
};
